import { CLOUD_ENVIRONMENT, DEP_ENVIRONMENT } from "../BaseUrl";

// Define environment-specific configuration settings
const EnvironmentConfig = {
  AWS: {
    // Determine bucket path based on DEP_ENVIRONMENT value
    BUCKET_PATH:
      DEP_ENVIRONMENT === "dev"
        ? "s3://dep-develop"
        : DEP_ENVIRONMENT === "uat"
        ? "s3://dep-vt-qa"
        : DEP_ENVIRONMENT === "prod"
        ? "s3://dep-prod"
        : "",

    // Determine bucket name based on DEP_ENVIRONMENT value
    BUCKET_NAME:
      DEP_ENVIRONMENT === "dev"
        ? "dep-develop"
        : DEP_ENVIRONMENT === "uat"
        ? "dep-vt-qa"
        : DEP_ENVIRONMENT === "prod"
        ? "dep-prod"
        : "",

    // Default connection type and name
    connectionType: "emr",
    connectionName: "emr",

    POSTGRES_DATABASE_WAREHOUSE:
      DEP_ENVIRONMENT === "dev"
        ? "VoyagerDataWarehouse"
        : DEP_ENVIRONMENT === "uat"
        ? "VoyagerDataWarehouse"
        : DEP_ENVIRONMENT === "prod"
        ? "VoyagerDataWarehouse"
        : "",

    BENCHLING_POSTGRES_DATABASE_WAREHOUSE:
      DEP_ENVIRONMENT === "dev"
        ? "Warehouse"
        : DEP_ENVIRONMENT === "uat"
        ? "Warehouse"
        : DEP_ENVIRONMENT === "prod"
        ? "Warehouse"
        : "",
  },
};

// Function to get environment-specific configuration
export function getEnvironmentConfig() {
  // Return the configuration for the specified CLOUD_ENVIRONMENT
  return {
    ...EnvironmentConfig[CLOUD_ENVIRONMENT],
    cloudEnvironment: CLOUD_ENVIRONMENT,
  };
}
